import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Stack } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Panel } from './panel';
import { getStyles } from './style';
import { FixedPanel } from './fixed-panel';

export const Collapse = (props) => {
  const {
    className,
    activeKeys,
    setActiveKeys,
    checkItems,
    skipItemsTypeCheck,
    allPanelItems,
  } = props;

  const classes = useDefaultStyles(getStyles);
  const i18n = useContext(I18nContext);
  const renderPanels = () => {
    const newChildren = [];
    React.Children.forEach(props.children, (child, index) => {
      if (!child) {
        return;
      }
      const { type: childType, key } = child;
      if (!skipItemsTypeCheck && !(childType.name === Panel.name || childType.displayName === Panel.name || childType.name === FixedPanel.name || childType.displayName === FixedPanel.name)) {
        // eslint-disable-next-line no-console
        console.warn('Warning: The child component type of Collapse must be Panel or FixedPanel');
        return;
      }

      if (checkItems && !allPanelItems.includes(key)) return;

      const isActive = activeKeys && activeKeys.indexOf(key) > -1;
      const newProps = {
        id: key === undefined ? index : key,
        activeKeys,
        isActive,
        setActiveKeys,
      };

      newChildren.push(React.cloneElement(child, newProps));
    });

    if (checkItems && allPanelItems.length === 0) {
      return (<div className="empty-collapse"><span>{i18n.getString(_TL_('There is no target supported'))}</span></div>);
    }

    return newChildren;
  };

  return (
    <Stack className={classnames(classes.collapseContainer, className, 'collapse-container')}>
      {renderPanels()}
    </Stack>
  );
};

Collapse.propTypes = {
  className: PropTypes.string,
  activeKeys: PropTypes.arrayOf(PropTypes.string),
  allPanelItems: PropTypes.arrayOf(PropTypes.string),
  setActiveKeys: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  checkItems: PropTypes.bool,
  skipItemsTypeCheck: PropTypes.bool,
};

Collapse.defaultProps = {
  className: '',
  activeKeys: [],
  checkItems: false,
  skipItemsTypeCheck: false,
  allPanelItems: [],
};
